define.alias("shared/components/shared/ui/group-avatar", "calendar/components/shared/ui/group-avatar");